var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.8791V6.70706C9.00004 6.50931 9.05871 6.31601 9.1686 6.1516C9.27848 5.98719 9.43465 5.85905 9.61734 5.78338C9.80004 5.70771 10.0011 5.68791 10.195 5.72648C10.389 5.76505 10.5671 5.86025 10.707 6.00006L16.293 11.5861C16.4805 11.7736 16.5858 12.0279 16.5858 12.2931C16.5858 12.5582 16.4805 12.8125 16.293 13.0001L10.707 18.5861C10.5671 18.7259 10.389 18.8211 10.195 18.8596C10.0011 18.8982 9.80004 18.8784 9.61734 18.8027C9.43465 18.7271 9.27848 18.5989 9.1686 18.4345C9.05871 18.2701 9.00004 18.0768 9 17.8791Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTri);
export default __webpack_public_path__ + "static/media/tri.7341a1c5dc28b1bee62a8729cc40765a.svg";
export { ForwardRef as ReactComponent };